import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import OERIcon from './component/EventIcon';
import VideoFlag from '../../FlagVideo/FlagVideo';
import DeleteVideo from '../../DeleteVideo';

class VideoCardActions extends React.Component {
  static propTypes = {
    canDelete: PropTypes.bool,
    askDeleteConfirmation: PropTypes.bool,
    isInternal: PropTypes.bool,
    media: PropTypes.shape({
      mediaId: PropTypes.string.isRequired,
      oer: PropTypes.string,
      status: PropTypes.string,
      triggerType: PropTypes.string.isRequired
    }).isRequired,
    // SEE PNVI-5632
    addFilterOnOERClick: PropTypes.func.isRequired,
    onDeleteVideo: PropTypes.func,
    addOnDemandFilter: PropTypes.func.isRequired,
    onFlagVideo: PropTypes.func.isRequired,
    locale: PropTypes.string
  };

  static defaultProps = {
    locale: 'en',
    canDelete: false,
    isInternal: false,
    askDeleteConfirmation: true,
    onDeleteVideo: () => {}
  }

  handleClickEvent = event => {
    event.preventDefault();
    return this.props.addFilterOnOERClick(this.props.media.oer);
  }

  handleClickOnDemand = () => {
    this.props.addOnDemandFilter();
  }

  handleDeleteClick = () => {
    const {media, index} = this.props;
    this.props.onDeleteVideo(media, index);
  }

  renderDeleteButton() {
    const {media, canDelete, isInternal, askDeleteConfirmation} = this.props;

    if (canDelete || isInternal) {
      return (
        <DeleteVideo
          mediaId={media.mediaId}
          canDelete={canDelete && !isInternal}
          askConfirmation={askDeleteConfirmation}
          onDeleteVideo={this.handleDeleteClick}
        />
      );
    }
    return null;
  }

  // SEE PNVI-5635
  renderMediaStatus = media => {
    switch (media.status) {
      case 'coachCompleted':
        return (
          <IconButton>
            <Icon className="videoactions__coaching">supervisor_account</Icon>
          </IconButton>
        );
      case 'reviewCompleted':
        return (
          <IconButton>
            <Icon className="videoactions__reviewed_complete">assignment_turned_in</Icon>
          </IconButton>
        );
      case 'needReview':
        return (
          <IconButton>
            <Icon className="videoactions__tagged-active">local_offer</Icon>
          </IconButton>
        );
      case 'reviewed':
        return (
          <IconButton>
            <Icon className="videoactions__reviewed">check_circle</Icon>
          </IconButton>
        );
      default:
        return null;
    }
  }

  render() {
    const {media} = this.props;

    return (
      <CardActions className="videoactions">
        <div>
          <OERIcon
            handleClickOnDemand={this.handleClickOnDemand}
            handleClickEvent={this.handleClickEvent}
            mediaId={media.mediaId}
            eventType={media.oer}
            triggerType={media.triggerType}
            locale={this.props.locale}
          />
        </div>
        <div>
          {this.renderMediaStatus(media)}
          <VideoFlag
            mediaId={media.mediaId}
            flagged={media.flagged}
            onFlagVideo={this.props.onFlagVideo}
            className="videoactions__flagged"
          />
          {this.renderDeleteButton(media.mediaId)}
        </div>
      </CardActions>
    );
  }
}

export default VideoCardActions;
